import * as React from 'react'

import { Box, Icon, Table } from '@factorialco/deprecated-design-system'

type Props = {
  id: string
  onDelete: (rowId: string) => void
  children: React.ReactNode
}

const EditableTableRow: React.FC<Props> = ({ id, children, onDelete }) => {
  const [hover, setHover] = React.useState<boolean>(false)

  return (
    <Table.Row key={id}>
      {children}

      <Table.Cell width={40} padding="s0">
        <Box
          paddingX="s8"
          paddingY="s12"
          background={hover ? 'grey300' : 'grey100'}
          alignItems="center"
          border={{
            left: {
              width: 's1',
              color: 'grey400',
              style: 'solid',
            },
          }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={() => onDelete(id)}
        >
          <Icon.Medium icon="delete" />
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}

export default EditableTableRow
